/*jshint esversion: 6 */
import ios from './ios'
import android from './android'

const isIos = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || !!navigator.userAgent.match(/Intel Mac OS X 10_15/);

const isWeixin = () => {
	let ua = navigator.userAgent.toLowerCase();
	if (ua.match(/MicroMessenger/i) === "micromessenger") {
		return true
	} else {
		return false
	}
}

// 获取uid  因ios异步问题 操作比较复杂
const getUid = (callBack, ...args) => {
	let _uid
	if (isIos) {
		ios.get_ios_function('getInformation', '', function (info) {
			const userInfo = JSON.parse(info);
			_uid = userInfo.uid;
			callBack(_uid, ...args)
		});
	} else {
		const _usermsg = android.getUserInfo()
		_uid = _usermsg.uid
		callBack(_uid, ...args)
	}
}

const delayTodo = (fn, time) => {
	setTimeout(() => {
		fn()
	}, time)
}

// 跳转
const toPage = (iosStr, andStr) => {
	if (isIos) {
		let json = JSON.stringify({
			"type": "2",
			"link": iosStr
		});
		ios.get_ios_function("onJump", json, '');
	} else {
		window.JavaScript.startActivity(andStr)
	}
}

// 跳转
const toCustomPage = (type, link) => {
	if (isIos) {
		let json = JSON.stringify({
			"type": type,
			"link": link
		});
		ios.get_ios_function("onJump", json, '');
	} else {
		window.JavaScript.startActivity(`{"activity":"com.kingsoft.MessageDetailActivity","url":"${link}"}`)
	}
}

// 购买
const toBuy = (bookId, goodType, price, bookName, type = '', callBack, payType = 1) => {
	if (isIos) {
		let _uid
		const _callBack = () => {
			if (_uid !== "") {
				const buy_info = JSON.stringify({
					"book_id": bookId,
					"p_name": bookName,
					"p_price": price,
					"p_desc": bookName,
					"type": type, //默认可为空
					"bound": 0,
					"good_type": goodType,
					"pay_type": payType
				});
				ios.get_ios_function('onPay', buy_info, function (data) {
					callBack()
				})
			} else {
				ios.get_ios_function('onLogin', '', function (response) {
					callBack()
				});
			}
		}

		ios.get_ios_function('getInformation', '', function (info) {
			let userInfo = JSON.parse(info);
			_uid = userInfo.uid;
			_callBack()
		});
	} else {
		if (android.isLogin()) {
			const buy_info = {
				"book_id": bookId,
				"p_name": bookName,
				"p_price": price,
				"p_desc": bookName,
				"type": type,
				"bound": 0,
				"good_type": goodType
			};
			android.buy(buy_info);
		} else {
			android.login();
		}

		window.fresh = function (event) {
			callBack(event)
		}
	}
}
// toPay和toBuy本质没区别，传参简单些
const toPay = (data,callback) => {
	// console.log('toPay')
	// console.log(data)
	if (isIos) {
		const dataString = JSON.stringify(data)
		// console.log(dataString,'Utils.js')
		ios.get_ios_function('onPay', dataString, () => {
			callback()
		})
	} else {
		android.buy(data)
		window.fresh = function () {
			console.log('wahahahahahah')
			callback()
		}
	}
}

const toAndroidContinouationFee = (data) => {
	return new Promise(resolve => {
		const activityObjStr = JSON.stringify({
			activity: 'com.kingsoft.pay.PayContrantActivity',
			...data
		})

		window.JavaScript.startActivity(activityObjStr)
		window.fresh = function () {
			resolve()
			window.location.reload()
		}
	})
}

const recoveryPurchase = () => {
	ios.get_ios_function('onRecoveryGoods', '', null)
}

const isLogin = _ => {
	return new Promise((resolve, reject) => {
		try {
			if (isIos) {
				ios.get_ios_function('getInformation', '', info => {
					let userInfo = JSON.parse(info)
					console.log(userInfo)
					if (userInfo.uid) {
						resolve(true)
					} else {
						reject()
					}

					return
				})
			} else {
				if (android.isLogin()) {
					resolve(true)
				} else {
					reject()
				}
			}
		} catch (E) {
			console.warn(E)
			reject()
		}
	})
}

const autoLogin = () => {
	return new Promise((resolve, reject) => {
		if (isIos) {
			ios.get_ios_function('onLogin', '', function () {
				ios.get_ios_function('getInformation', '', info => {
					// ios 在登录成功返回页面后，页面的上下文环境似乎是被覆盖了，
					// resolve 和 callback 都不能达到预期的效果，所幸 reload 在这里面可以用
					window.location.reload()
					// callBack(JSON.parse(info))
				})
			});

			return
		} else {
			android.login();
			// 这fresh方法就贼神奇，login完了自动触发，MDN没查到这个方法
			window.fresh = function () {
				const info = JSON.parse(window.JavaScript.getInformation())
				resolve(info)
				// window.location.reload()
			}
			return
		}
	})
}

const getUserInfo = (cb) => {
	return new Promise((resolve, reject) => {
		if (isIos) {
			ios.get_ios_function('getInformation', '', info => {
				resolve(JSON.parse(info))
			})
		} else {
			const res = JSON.parse(window.JavaScript.getInformation())
			resolve(res)
		}
	})
}

const signature = (data) => {
	return new Promise((resolve, reject) => {
		if (isIos) {
			ios.get_ios_function('getInformation', '', info => {
				console.log(info)
				const userInfo = JSON.parse(info);
				data.uid = userInfo.uid;
				data.v = userInfo.v;
				data.sv = userInfo.sv;
				data.uuid = userInfo.uuid;
				data.nonce_str = ('50' + Math.random()).substr(3, 5);
				data.auth_key = 1000005;
				data.client = 3;
				data.timestamp = Date.parse(new Date()) / 1000;

				ios.get_ios_function('getSignature', data, function (response) {
					data.signature = response
					resolve(data)
				});
			})
		} else {
			const userInfo = android.getUserInfo()
			data.uid = userInfo.uid;
			data.v = userInfo.v;
			data.sv = userInfo.sv;
			data.uuid = userInfo.uuid;
			data.auth_nonce = ('50' + Math.random()).substr(3, 5);
			data.auth_key = "100006";
			data.client = 1;
			data.timestamp = Date.parse(new Date()) / 1000;

			const sign = android.getSignatureForPHP(data)

			data.signature = sign

			resolve(data)
		}
	})
}

const pageBack = (shouldExit) => {
	if (isIos) {
		ios.get_ios_function('onBackClick', '', () => {
			console.log('back')
		})
	} else {
		shouldExit ? window.JavaScript.onBackClick() : window.history.back()
	}
}

// const getToken = () => {
// 	if (isIos) {
// 		return ''
// 	} else {
// 		return window.JavaScript.getToken()
// 	}
// }

export default {
	getUid,
	isIos,
	isWeixin,
	delayTodo,
	toPage,
	toCustomPage,
	toBuy,
	toPay,
	recoveryPurchase,
	toAndroidContinouationFee,
	isLogin,
	autoLogin,
	getUserInfo,
	signature,
	pageBack
}